export default __webpack_public_path__ + "static/media/bagIcon.585bd5b6.svg";